export const localeToLangKey = locale => (locale === 'en' ? 'Eng' : 'Cht');
